export const findConfig = function(configToFind, configArray) {
	let foundConfigIndex = -1;
	let foundConfig;

	if (configArray && configArray.length > 0) {
		if (configToFind.id) {
			foundConfigIndex = configArray.findIndex(
				c => c.id === configToFind.id
			);
		}

		if (foundConfigIndex < 0) {
			foundConfigIndex = configArray.findIndex(
				c =>
					c.configurationKeyId === configToFind.configurationKeyId &&
					c.companyId === configToFind.companyId &&
					(c.entityId === configToFind.entityId ||
						c.entityId === 0) &&
					c.entityTypeId === configToFind.entityTypeId
			);
		}

		if (foundConfigIndex >= 0) {
			foundConfig = configArray[foundConfigIndex];
		}
	}

	return {
		index: foundConfigIndex,
		config: foundConfig
	};
};
